import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import TasksService from "services/TasksService";


export const createTask = createAsyncThunk(
  "tasks/createTask",
  async (data, { rejectWithValue }) => {
    const { picFile, ...taskData } = data;
    try {
      const response = await TasksService.addTask(taskData);
      const id = response.data.id;

      const promises = [];

      if (picFile) {
        const form2 = new FormData();
        form2.append("picFile", picFile.file);
        promises.push(TasksService.uploadTaskPhoto(form2, id));
      }

      await Promise.all(promises);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data.data.message || "Erreur");
    }

    // try {
    //   const response = await TasksService.addTask(data);
    //   return response.data;
    // } catch (error) {
    //   return rejectWithValue(error.response.data);
    // }
  }
);


export const fetchTasks = createAsyncThunk(
  "tasks/fetchTasks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await TasksService.getAllTasks();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message || "Erreur");
    }
  }
);


export const deleteTask = createAsyncThunk(
  "tasks/deleteTask",
  async (taskId, { rejectWithValue }) => {
    try {
      await TasksService.deleteTask(taskId);
      return taskId;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message || "Erreur");
    }
  }
);


const tasksSlice = createSlice({
  name: "tasks",
  initialState: {
    tasks: [],
    error: null,
    loading: false,
  },
  reducers: {
    

    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state, action) => {
      state.loading = false;
    },
    hideError: (state, action) => {
     
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    
    builder.addCase(createTask.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createTask.fulfilled, (state, action) => {
      state.loading = false;
      state.tasks.push(action.payload);
    });
    builder.addCase(createTask.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    
    builder.addCase(fetchTasks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTasks.fulfilled, (state, action) => {
      state.loading = false;
      state.tasks = action.payload;
    });
    builder.addCase(fetchTasks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteTask.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteTask.fulfilled, (state, action) => {
      state.loading = false;
      state.tasks = state.tasks.filter((task) => task.id !== action.payload);
    });
    builder.addCase(deleteTask.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default tasksSlice.reducer;
export const { showLoading, hideLoading, hideError  } = tasksSlice.actions;